import { Controller } from "@hotwired/stimulus"
import 'bootstrap-select'

export default class extends Controller {
  connect() {
    $('.selectpicker').selectpicker()
  }
}